import NavBar from './NavigationComponents/Navbar';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Contact from './ContactComponent';
import Home from './HomeComponent';
import Footer from './FooterComponent';
import Projects from './ProjectsComponent';
import Experience from './ExperienceComponent';




const Main=()=>{
        return(
            <BrowserRouter>
                <NavBar />
                <Routes>
                    <Route element={<Home/>} path='/'  exact />
                    <Route element={<Experience/>} path='/experience'  />
                    <Route element={<Projects/>} path='/projects'/>
                    <Route element={<Contact/>} path='/contact'/>
                </Routes> 
                <Footer /> 
            </BrowserRouter>
            

        );



    }



export default Main;



